export default "__VITE_ASSET__CHYh8J$F__"